<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px" :key="changeDex">
    <div class="container">
      <div class="form-group row" style="margin: 32px auto;">
        <label class="col-sm-2 control-label">Centres Name *</label>
        <div class="col-sm-10">
          <div>
            <select class="form-control centre-select" :disabled="!!refId" v-model="refId" name="refId" @change="onRefIdChange">
              <option disabled value="">Please select</option>
              <option v-for="centre in centresList.filter(({ type }) => type != '0')" :key="centre.id" :value="centre.id">
                {{ centre.titleEn }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li class="tabLi" :class="{ active: currentLang == 'EN' }">
          <a @click="currentLang = 'EN'">English</a>
        </li>
        <li class="tabLi" :class="{ active: currentLang == 'SC' }">
          <a @click="currentLang = 'SC'">Simplified Chinese</a>
        </li>
        <li class="tabLi" :class="{ active: currentLang == 'TC' }">
          <a @click="currentLang = 'TC'">Traditional Chinese</a>
        </li>
      </ul>
    </div>
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="panel-body" v-if="!isLoading">
        <div class="form-group">
          <label class="col-sm-3 control-label">Page Title *</label>
          <div class="col-sm-6" v-for="item in getTypeDataInAllLang('0')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <input class="form-control" readonly v-model="item.title" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">Page Description</label>
          <div class="col-sm-6" v-for="item in getTypeDataInAllLang('0')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <ckeditor v-model="item.subTitle" :editor="editor" :config="editorConfig"></ckeditor>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 control-label">Banner *</label>
          <div class="col-sm-6" v-for="item in getTypeDataInAllLang('0')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <div class="image-previewer">
              <img :src="item.imageBaseStr" v-if="item.imageBaseStr" />
            </div>
            <br />
            <input type="file" @change="changeImage($event, item.type)" />
          </div>
        </div>
        <hr />

        <h2>Manpower Projection</h2>

        <div class="form-group">
          <label class="col-sm-3 control-label">Title *</label>
          <div class="col-sm-6" v-for="item in getTypeDataInAllLang('1')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <input class="form-control" v-model="item.title" :disabled="isSectionDeleted(item.type)" />
          </div>
        </div>
        <div v-for="item in getTypeDataInAllLang('1')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
          <div class="playground" :class="{ 'section-disabled': isSectionDeleted(item.type) }" :id="'projection-playground-' + item.type.slice(0, 2)" v-html="item.content"></div>
          <div style="text-align: right; margin-top: 12px; display: flex; justify-content: flex-end; gap: 8px;">
            <button class="btn btn-sm btn-warning" :disabled="isSectionDeleted(item.type)" @click.prevent="resetSectionContent(1, currentLang)">Reset</button>
            <!-- <button v-if="!isSectionDeleted(item.type)" class="btn btn-sm btn-danger" @click.prevent="deleteSection(item.type)">Delete</button>
            <button v-else class="btn btn-sm btn-primary" @click.prevent="restoreSection(item.type)">Restore</button> -->
          </div>
        </div>
        <hr />

        <h2>Manpower Balance by Occupation Group</h2>

        <div class="form-group">
          <label class="col-sm-3 control-label">Title *</label>
          <div class="col-sm-6" v-for="item in getTypeDataInAllLang('2')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <input class="form-control" v-model="item.title" :disabled="isSectionDeleted(item.type)" />
          </div>
        </div>
        <div v-for="item in getTypeDataInAllLang('2')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
          <div class="playground" :class="{ 'section-disabled': isSectionDeleted(item.type) }" :id="'balance-playground-' + item.type.slice(0, 2)" v-html="item.content"></div>
          <div style="text-align: right; margin-top: 12px; display: flex; justify-content: flex-end; gap: 8px;">
            <button class="btn btn-sm btn-warning" :disabled="isSectionDeleted(item.type)" @click.prevent="resetSectionContent(2, currentLang)">Reset</button>
            <!-- <button v-if="!isSectionDeleted(item.type)" class="btn btn-sm btn-danger" @click.prevent="deleteSection(item.type)">Delete</button>
            <button v-else class="btn btn-sm btn-primary" @click.prevent="restoreSection(item.type)">Restore</button> -->
          </div>
        </div>
        <hr />

        <h2>Key Factors Impacting Outlook</h2>
        <div v-for="item in getTypeDataInAllLang('3')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
          <div class="playground" :class="{ 'section-disabled': isSectionDeleted(item.type) }" :id="'factor-playground-' + item.type.slice(0, 2)" style="margin-bottom: 12px ;">
            <div class="factor-grid cms-style__wrap">
              <div class="projection-content__right-content" v-for="(factor, index) in factors[item.type.slice(0, 2)]" :key="factor.id">
                <img :src="factor.image || defaultPlaceholder" :alt="factor.imgAlt || ''" style="flex: 0 0 25%; aspect-ratio: 1; cursor: pointer;" @click="triggerUploadFor(item.type.slice(0, 2), index)" />
                <p class="Bold font-size-21">
                  <span contenteditable="true" v-editable-display="factor.text || $t('message.editText')" @input="updateText($event, item.type.slice(0, 2), index)"></span>
                </p>
                <div style="display: flex; gap: 4px; justify-content: center; align-items: center; position: absolute; inset: auto 4px 4px">
                  <span class="website_hide item-url" contenteditable="true" style="flex: 1 0 auto" v-editable-display="factor.url || '[URL]'" @input="updateFactorUrl($event, item.type.slice(0, 2), index)"></span>
                  <button type="button" class="btn btn-sm btn-warning" v-if="factor.image" @click="clearImage(item.type.slice(0, 2), index)">Clear Image</button>
                  <button type="button" class="btn btn-sm btn-danger" @click="removeFactor(item.type.slice(0, 2), index)">Remove</button>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; gap: 8px; justify-content: flex-end;">
            <button type="button" class="btn btn-primary" :disabled="isSectionDeleted(item.type)" @click="addFactor(item.type.slice(0, 2))">Add Factor</button>
            <!-- <button v-if="!isSectionDeleted(item.type)" type="button" class="btn btn-danger" @click="deleteSection(item.type)">Delete</button>
            <button v-else type="button" class="btn btn-primary" @click="restoreSection(item.type)">Restore</button> -->
          </div>
        </div>
        <hr />

        <h2>Occupations in Demand</h2>
        <div v-for="item in getTypeDataInAllLang('4')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
          <div v-for="(demandSet, setIndex) in demands[item.type.slice(0, 2)]" :key="demandSet.id">
            <div class="form-group" style="margin-bottom: 10px;">
              <label class="col-sm-3 control-label">Title of Demand Set {{ setIndex + 1 }}</label>
              <div class="col-sm-6">
                <input type="text" class="form-control" v-model="demandSet.title" @input="syncDemandsToPageData(item.type.slice(0, 2))" />
              </div>
              <div class="col-sm-3" style="display: flex; justify-content: flex-end;">
                <button type="button" class="btn btn-sm btn-danger" @click="removeDemandSet(item.type.slice(0, 2), setIndex)">Remove Set</button>
              </div>
            </div>
            <div class="playground" :id="'demand-playground-' + item.type.slice(0, 2) + '-' + setIndex" style="margin-bottom: 12px ;">
              <div class="factor-grid cms-style__wrap">
                <div class="projection-content__right-content" v-for="(demand, index) in demandSet.items" :key="demand.id">
                  <img :src="demand.image || defaultPlaceholder" :alt="demand.imgAlt || ''" style="flex: 0 0 25%; aspect-ratio: 1; cursor: pointer;" @click="triggerDemandUpload(item.type.slice(0, 2), setIndex, index)" />
                  <p class="Bold font-size-21">
                    <span contenteditable="true" v-editable-display="demand.text || $t('message.editText')" @input="updateDemandText($event, item.type.slice(0, 2), setIndex, index)"></span>
                  </p>
                  <div style="display: flex; gap: 4px; justify-content: center; align-items: center; position: absolute; inset: auto 4px 4px">
                    <span class="website_hide item-url" contenteditable="true" style="flex: 1 0 80%" v-editable-display="demand.url || '[URL]'" @input="updateDemandUrl($event, item.type.slice(0, 2), setIndex, index)"></span>
                    <button type="button" class="btn btn-sm btn-warning" v-if="demand.image" @click="clearDemandImage(item.type.slice(0, 2), setIndex, index)">Clear Image</button>
                    <button type="button" class="btn btn-sm btn-danger" @click="removeDemand(item.type.slice(0, 2), setIndex, index)">Remove</button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-primary" @click="addDemand(item.type.slice(0, 2), setIndex)">Add Demand</button>
            </div>
          </div>
          <button type="button" class="btn btn-primary" @click="addDemandSet(item.type.slice(0, 2))">Add Section</button>
        </div>
        <hr />

        <h2>Essential Skills</h2>
        <div v-for="item in getTypeDataInAllLang('5')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
          <div class="playground playground--link" :class="{ 'section-disabled': isSectionDeleted(item.type) }" :id="'skills-playground-' + item.type.slice(0, 2)" v-html="sanitizeHtml(item.content)" :data-type-id="item.type"></div>
          <div style="display: flex; gap: 8px; justify-content: flex-end;">
            <button type="button" class="btn btn-primary" :disabled="isSectionDeleted(item.type)" @click="addSectionLinkItem('#skills-playground-' + item.type.slice(0, 2))">Add Item</button>
            <!-- <button v-if="!isSectionDeleted(item.type)" type="button" class="btn btn-danger" @click="deleteSection(item.type)">Hide</button>
            <button v-else type="button" class="btn btn-primary" @click="restoreSection(item.type)">Show</button> -->
          </div>
        </div>
        <hr />

        <h2>Essential Knowledge</h2>
        <div v-for="item in getTypeDataInAllLang('6')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
          <div class="playground playground--link" :class="{ 'section-disabled': isSectionDeleted(item.type) }" :id="'knowledge-playground-' + item.type.slice(0, 2)" v-html="sanitizeHtml(item.content)" :data-type-id="item.type"></div>
          <div style="display: flex; gap: 8px; justify-content: flex-end;">
            <button type="button" class="btn btn-primary" :disabled="isSectionDeleted(item.type)" @click="addSectionLinkItem('#knowledge-playground-' + item.type.slice(0, 2))">Add Item</button>
            <!-- <button v-if="!isSectionDeleted(item.type)" type="button" class="btn btn-danger" @click="deleteSection(item.type)">Hide</button>
            <button v-else type="button" class="btn btn-primary" @click="restoreSection(item.type)">Show</button> -->
          </div>
        </div>
        <hr />

        <h2>Remarks</h2>
        <div class="form-group">
          <label class="col-sm-3 control-label">Content</label>
          <div class="col-sm-6" v-for="item in getTypeDataInAllLang('10')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <div :class="{ 'remark-editor--disabled': isSectionDeleted(item.type) }">
              <ckeditor
                v-model="item.content"
                :editor="editor"
                :config="editorConfig"
                :disabled="isSectionDeleted(item.type)"
                @input="onRemarkContentInput(item.type, item.content)"
              ></ckeditor>
            </div>
          </div>
          <div class="col-sm-3" v-for="item in getTypeDataInAllLang('10')" :key="item.type" :class="currentLang == item.type.slice(0, 2)? '' : 'sr-only'">
            <button
              v-if="!isSectionDeleted(item.type)"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSection(item.type)"
            >
              Hide
            </button>
            <button
              v-else
              type="button"
              class="btn btn-sm btn-primary"
              @click="restoreSection(item.type)"
            >
              Show
            </button>
          </div>
        </div>
        <hr/>
        
        <div class="hr-line-dashed"></div>
        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <button type="button" class="btn btn-primary" @click="submitDetail">Save</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <input id="hiddenFileInput" ref="hiddenFile" type="file" accept="image/*" style="display: none" @change="onHiddenFileChange" />
  </div>
</template>

<script>
const upload = require("../upload");
import axios from "axios";
import config from "../config";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../style/web-pages.css";

const DEFAULT_PLACEHOLDER =
  "data:image/png;base64,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";


const section1Node = `<div class="manpower-blk Regular">
                <div class="manpower-blk__row">
                  <div class="manpower-blk__item">
                    <h3>
                      <span contenteditable="true">Manpower Requirements for 2028</span>
                    </h3>
                    <div class="manpower-blk__item-row">
                      <img src="/images/eightCentre/mip-icon-manpower-requirements-B.png" alt="" />
                      <div contenteditable="true" class="Bold font-size-36">0</div>
                    </div>
                  </div>

                  <div class="manpower-blk__br"></div>

                  <div class="manpower-blk__item">
                    <h3>
                      <u>
                        <span contenteditable="true">From 2023 to 2028</span>
                      </u>
                    </h3>
                    <div class="manpower-blk__item-row">
                      <div class="manpower-blk__item">
                        <b contenteditable="true">Projected change</b>
                        <div class="manpower-blk__item-row">
                          <img src="/images/eightCentre/mip-icon-manpower-requirements-.png" alt="" />
                          <div contenteditable="true" class="Bold font-size-36">+36 100</div>
                        </div>
                      </div>
                      <div class="manpower-blk__item">
                        <b contenteditable="true">Annual change</b>
                        <div class="manpower-blk__item-row">
                          <img src="/images/eightCentre/mip-icon-represent--annual-change-.png" alt="" />
                          <div contenteditable="true" class="Bold font-size-36">+9.8%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div class="manpower-blk__row">
                  <div class="manpower-blk__item">
                    <h3 contenteditable="true">Sectoral Manpower Balance</h3>
                    <div class="manpower-blk__item-row">
                      <img src="/images/eightCentre/mip-icon-represent--puzzle-.png" />
                      <div contenteditable="true" class="Bold font-size-36">2023</div>
                    </div>
                  </div>
                </div>
              </div>`;
const section2Node = `<div class="occupation-group__content flex occupation-group cms-style__occupation">
                <div class="occupation-card">
                  <p class="Bold" contenteditable="true">Managers, supervisors and professionals</p>
                  <img src="/images/eightCentre/an-icon-representing--managers--supervisors-and-pr.png" />
                  <p><span contenteditable="true">-17 000 to -21 000</span></p>
                </div>
                <div class="occupation-card">
                  <p class="Bold" contenteditable="true">Service industry workers</p>
                  <img src="/images/eightCentre/three-people--one-with-headset-and-microphone-and- (1).png" />
                  <p><span contenteditable="true">-500 to -1 500</span></p>
                </div>
                <div class="occupation-card">
                  <p class="Bold" contenteditable="true">Skilled technical workers</p>
                  <img src="/images/eightCentre/three-people--one-with-construction-helmet--one-wi.png" />
                  <p><span contenteditable="true">Within ±500</span></p>
                </div>
                <div class="occupation-card">
                  <p class="Bold" contenteditable="true">Manual labourers</p>
                  <img src="/images/eightCentre/three-half-body-people--one-person-with-mini-broom (2).png" />
                  <p><span contenteditable="true">Not applicable</span></p>
                </div>
              </div>`
const linksRowNode =  `<div class="diamond-icon">
  <div class="occupation_link" contenteditable="true">[LABEL]</div>
    <div class="website_hide item-url" contenteditable="true">[URL]</div>
    <div class="website_hide link-remove-btn" >Remove</div>
  </div>`;

const syncEditableDisplay = (el, value) => {
  if (document.activeElement === el) return;
  const next = value == null ? "" : String(value);
  if (el.textContent !== next) el.textContent = next;
};

export default {
  mixins: [config.globalMixin],
  directives: {
    editableDisplay: {
      bind(el, binding) {
        syncEditableDisplay(el, binding.value);
      },
      update(el, binding) {
        syncEditableDisplay(el, binding.value);
      },
    },
  },
  data() {
    return {
      changeDex: 0,
      isLoading: true,
      defaultPlaceholder: DEFAULT_PLACEHOLDER,
      factors: {
        EN: [{ id: Date.now(), text: "", url: "", image: null, imgAlt: "Factor Image" }],
        TC: [{ id: Date.now() + 1, text: "", url: "", image: null, imgAlt: "Factor Image" }],
        SC: [{ id: Date.now() + 2, text: "", url: "", image: null, imgAlt: "Factor Image" }],
      },
      demands: {
        EN: [{ id: Date.now() + 3, title: "Occupations in Demand", items: [{ id: Date.now() + 6, text: "", url: "", image: null, imgAlt: "Demand Image" }] }],
        TC: [{ id: Date.now() + 4, title: "需求職業", items: [{ id: Date.now() + 7, text: "", url: "", image: null, imgAlt: "Demand Image" }] }],
        SC: [{ id: Date.now() + 5, title: "需求职业", items: [{ id: Date.now() + 8, text: "", url: "", image: null, imgAlt: "Demand Image" }] }],
      },
      deletedDemandRowIds: {
        EN: [],
        TC: [],
        SC: [],
      },
      // { id: Date.now(), image: null, imgAlt: "", text: "2023", _objectUrl: null }
      linkRemoveHandler: null,
      activeIndex: null,
      activeDemandSetIndex: null,
      activeLangCode: "EN",
      activeUploadSection: null,
      detailId: "",
      centresList: [],

      currentLang: "EN",
      refId: parseInt(this.$route.query.refId) || "",

      pageData: {

        "EN-0": { // page head section
          type: "EN-0", title: "", subTitle: "", imageBaseStr: null,
        },
        "EN-1": { // Manpower Projection
          type: "EN-1", title: "", subTitle: "", image: null, content: section1Node,
        },
        "EN-2": { // Manpower Balance by Occupation Group
          type: "EN-2", title: "", subTitle: "", image: null, content: section2Node,
        },
        "EN-3": { // Key Factors Impacting Outlook
          type: "EN-3", title: "", subTitle: "", image: null, content: "",
        },
        "EN-4": [], // Occupations in Demand (can have multiple records)
        "EN-5": { // Essential Skills
          type: "EN-5", title: "", subTitle: "", image: null, content: linksRowNode,
        },
        "EN-6": { // Essential Knowledge
          type: "EN-6", title: "", subTitle: "", image: null, content: linksRowNode,
        },
        "EN-10": { // Remarks
          type: "EN-10", content: "",
        },

        "TC-0": { type: "TC-0", title: "", subTitle: "", imageBaseStr: null,  },
        "TC-1": { type: "TC-1", title: "", subTitle: "", image: null, content: section1Node, },
        "TC-2": { type: "TC-2", title: "", subTitle: "", image: null, content: section2Node, },
        "TC-3": { type: "TC-3", title: "", subTitle: "", image: null, content: "", },
        "TC-4": [],
        "TC-5": { type: "TC-5", title: "", subTitle: "", image: null, content: linksRowNode, },
        "TC-6": { type: "TC-6", title: "", subTitle: "", image: null, content: linksRowNode, },
        "TC-10": { type: "TC-10", content: "", },

        "SC-0": { type: "SC-0", title: "", subTitle: "", imageBaseStr: null,  },
        "SC-1": { type: "SC-1", title: "", subTitle: "", image: null, content: section1Node, },
        "SC-2": { type: "SC-2", title: "", subTitle: "", image: null, content: section2Node, },
        "SC-3": { type: "SC-3", title: "", subTitle: "", image: null, content: "", },
        "SC-4": [],
        "SC-5": { type: "SC-5", title: "", subTitle: "", image: null, content: linksRowNode, },
        "SC-6": { type: "SC-6", title: "", subTitle: "", image: null, content: linksRowNode, },
        "SC-10": { type: "SC-10", content: "", },
      },

      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ["Table"],
        extraPlugins: [upload.MyCustomUploadAdapterPlugin],
      },
      editorReady: false,
      addImage: "",
      synonyms: "",
    };
  },
  async created() {
    await this.loadCentres();
    if(!this.$data.refId){
      this.$data.isLoading = false
      return
    }
    await this.loadDetail(this.$data.refId);
  },

  mounted() {
    this.linkRemoveHandler = (e) => {
      e.preventDefault();

      const removeBtn = e.target && e.target.closest ? e.target.closest(".link-remove-btn") : null;
      if (!removeBtn) return;

      const targetItem = removeBtn.closest(".diamond-icon");
      const targetSection = removeBtn.closest(".playground--link");
      if (!targetSection) return;

      const targetType = targetSection.dataset ? targetSection.dataset.typeId : null;
      if (targetItem) {
        targetItem.remove();
      }
      if (targetType && this.$data.pageData[targetType]) {
        this.$set(this.$data.pageData[targetType], "content", targetSection.innerHTML);
      }
    };
    $(document).on("click", ".playground--link .link-remove-btn", this.linkRemoveHandler);

  },
  beforeDestroy() {
    if (this._searchDetailCancelSource) {
      this._searchDetailCancelSource.cancel();
      this._searchDetailCancelSource = null;
    }
    if (this.linkRemoveHandler) {
      $(document).off("click", ".playground--link .link-remove-btn", this.linkRemoveHandler);
      this.linkRemoveHandler = null;
    }
  },
  methods: {
    // getRowDataByType(langCode, typeId) {
    //   return this.$data.pageData[`${langCode, typeId}-${langCode, typeId}`] || null
    // },
    getTypeDataInAllLang(typeStr){
      return Object.entries(this.pageData).reduce((acc, [key, item]) => {
        if (Array.isArray(item)) {
          if (typeStr === "4") acc.push({ type: key });
          return acc;
        }
        if (item && typeof item.type === "string" && item.type.endsWith(`-${typeStr}`)) {
          acc.push(item);
        }
        return acc;
      }, []);
    },
    createDefaultFactor() {
      return {
        id: Date.now() + Math.floor(Math.random() * 1000),
        text: this.$t("message.editText"),
        url: "",
        image: null,
        imgAlt: "Factor Image",
      };
    },
    normalizeFactorUrl(url) {
      if (!url || typeof url !== "string") return "";
      const normalized = url.trim();
      if (!normalized || normalized === "[URL]") return "";
      return normalized;
    },
    createDefaultDemand() {
      return {
        id: Date.now() + Math.floor(Math.random() * 1000),
        text: this.$t("message.editText"),
        url: "",
        image: null,
        imgAlt: "Demand Image",
      };
    },
    getDefaultDemandTitle(langCode) {
      const titleMap = {
        EN: "Occupations in Demand",
        TC: "需求職業",
        SC: "需求职业",
      };
      return titleMap[langCode] || "Occupations in Demand";
    },
    createDefaultDemandSet(langCode) {
      return {
        id: Date.now() + Math.floor(Math.random() * 1000),
        rowId: null,
        title: this.getDefaultDemandTitle(langCode),
        items: [this.createDefaultDemand()],
      };
    },
    normalizeDemandItems(items) {
      if (!Array.isArray(items) || !items.length) return [this.createDefaultDemand()];
      return items.map((item, index) => ({
        id: (item && item.id) || Date.now() + index,
        text: (item && item.text) || this.$t("message.editText"),
        url: this.normalizeDemandUrl((item && item.url) || ""),
        image: this.normalizeFactorImage((item && item.image) || ""),
        imgAlt: (item && item.imgAlt) || "Demand Image",
      }));
    },
    normalizeDemandUrl(url) {
      if (!url || typeof url !== "string") return "";
      const normalized = url.trim();
      if (!normalized || normalized === "[URL]") return "";
      return normalized;
    },
    parseDemandRows(demandRows, langCode) {
      if (!demandRows.length) {
        return [this.createDefaultDemandSet(langCode)];
      }

      const parsedSets = [];
      for (let rowIndex = 0; rowIndex < demandRows.length; rowIndex += 1) {
        const row = demandRows[rowIndex];
        const fallbackTitle = row.title || this.getDefaultDemandTitle(langCode);
        const fallbackSetId = row.id || `${langCode}-new-${rowIndex}`;
        const fallbackRowId = row.id || null;

        const setsFromHtml = this.parseDemandContent(row.content || "", fallbackTitle, langCode);
        if (Array.isArray(setsFromHtml) && setsFromHtml.length) {
          for (let setIndex = 0; setIndex < setsFromHtml.length; setIndex += 1) {
            const set = setsFromHtml[setIndex];
            parsedSets.push({
              id: (set && set.id) || `${fallbackSetId}-${setIndex}`,
              rowId: setIndex === 0 ? fallbackRowId : null,
              title: (set && set.title) || fallbackTitle,
              items: this.normalizeDemandItems((set && set.items) || []),
            });
          }
        } else {
          parsedSets.push({
            id: fallbackSetId,
            rowId: fallbackRowId,
            title: fallbackTitle,
            items: this.normalizeDemandItems([]),
          });
        }
      }

      return parsedSets.length ? parsedSets : [this.createDefaultDemandSet(langCode)];
    },
    escapeHtml(text = "") {
      return String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    normalizeFactorImage(src) {
      if (!src) return null;
      if (src.startsWith("data:image")) return src;
      if (src.startsWith("http") || src.startsWith("/")) return src;
      return `data:image/png;base64,${src}`;
    },
    // Note: Parse the html format of Key Factors Content for CMS Editor
    parseFactorContent(html) {
      if (!html) return [this.createDefaultFactor()];

      const parser = new DOMParser();
      const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
      const cards = doc.querySelectorAll(".projection-content__right-content");

      const parsed = Array.from(cards).map((card, index) => {
        const img = card.querySelector("img");
        const textNode = card.querySelector(".Bold.font-size-21 span, .Bold.font-size-21");
        const itemUrlNode = card.querySelector(".item-url");
        const linkNode = card.querySelector(".Bold.font-size-21 a, .occupation_link, a");
        const text = (textNode && textNode.textContent ? textNode.textContent : "").trim();
        const itemUrl = (itemUrlNode && itemUrlNode.textContent ? itemUrlNode.textContent : "").trim();
        const linkHref = (linkNode && linkNode.getAttribute ? (linkNode.getAttribute("href") || "") : "").trim();
        const rawSrc = img ? img.getAttribute("src") : "";

        return {
          id: Date.now() + index,
          text: text || this.$t("message.editText"),
          url: this.normalizeFactorUrl(itemUrl || linkHref),
          image: this.normalizeFactorImage(rawSrc),
          imgAlt: (img && img.getAttribute("alt")) || "Factor Image",
        };
      }).filter((factor) => factor.text || factor.image);

      return parsed.length ? parsed : [this.createDefaultFactor()];
    },
    // Note: The html format of Key Factors Content to Home Page
    buildFactorContent(langCode) {
      const list = this.factors[langCode] || [];
      const editText = this.$t("message.editText");
      return list.map((factor) => {
        if (!factor) return "";
        const src = this.escapeHtml(factor.image || this.defaultPlaceholder);
        const alt = this.escapeHtml(factor.imgAlt || "");
        const text = this.escapeHtml(factor.text || editText);
        const url = this.normalizeFactorUrl(factor.url || "");
        const hrefAttr = url ? ' href="' + this.escapeHtml(url) + '"' : "";
        return (
          '<div class="projection-content__right-content">' +
          '<img src="' + src + '" alt="' + alt + '" style="flex: 0 0 25%; aspect-ratio: 1;" />' +
          '<p class="Bold font-size-21">' +
          '<a' + hrefAttr + '>' + text + '</a>' +
          '</p>' +
          '</div>'
        );
      }).join("");
    },
    // Note: The html format of Demand Set Content to Home Page
    buildDemandSetContent(demandSet) {
      const items = (demandSet && Array.isArray(demandSet.items)) ? demandSet.items : [];
      const editText = this.$t("message.editText");
      return items.map((item) => {
        if (!item) return "";
        const src = this.escapeHtml(item.image || this.defaultPlaceholder);
        const alt = this.escapeHtml(item.imgAlt || "");
        const text = this.escapeHtml(item.text || editText);
        const url = this.normalizeDemandUrl(item.url || "");
        const hrefAttr = url ? ' href="' + this.escapeHtml(url) + '"' : "";
        return (
          '<div class="projection-content__right-content">' +
          '<img src="' + src + '" alt="' + alt + '" style="flex: 0 0 25%; aspect-ratio: 1;" />' +
          '<p class="Bold font-size-21">' +
          '<a' + hrefAttr + '>' + text + '</a>' +
          '</p>' +
          '</div>'
        );
      }).join("");
    },
    // Note: Parse a single demand row's `content` HTML into one demand set For CMS Editor.
    parseDemandContent(content, titleFromRow, langCode) {
      const defaultTitle =
        (typeof titleFromRow === "string" && titleFromRow.trim()) ||
        this.getDefaultDemandTitle(langCode);

      if (!content || !String(content).trim()) {
        const defaultSet = this.createDefaultDemandSet(langCode);
        defaultSet.title = defaultTitle;
        return [defaultSet];
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(`<div>${content}</div>`, "text/html");
      const cards = doc.querySelectorAll(".projection-content__right-content");
      const items = Array.from(cards).map((card, index) => {
        const img = card.querySelector("img");
        const textNode = card.querySelector(".Bold.font-size-21 span, .Bold.font-size-21");
        const itemUrlNode = card.querySelector(".item-url");
        const linkNode = card.querySelector(".Bold.font-size-21 a, .occupation_link, a");
        const text = (textNode && textNode.textContent ? textNode.textContent : "").trim();
        const itemUrl = (itemUrlNode && itemUrlNode.textContent ? itemUrlNode.textContent : "").trim();
        const linkHref = (linkNode && linkNode.getAttribute ? (linkNode.getAttribute("href") || "") : "").trim();
        const rawSrc = img ? img.getAttribute("src") : "";

        return {
          id: Date.now() + index,
          text: text || this.$t("message.editText"),
          url: this.normalizeDemandUrl(itemUrl || linkHref),
          image: this.normalizeFactorImage(rawSrc),
          imgAlt: (img && img.getAttribute("alt")) || "Demand Image",
        };
      }).filter((item) => item.text || item.image);

      return [{
        id: Date.now(),
        title: defaultTitle,
        items: items.length ? items : this.normalizeDemandItems([]),
      }];
    },
    // Note: Sync the Key Factors Content to Page Data For CMS Editor.
    syncFactorsToPageData(langCode) {
      const typeId = `${langCode}-3`;
      if (!this.pageData[typeId]) return;
      this.$set(this.pageData[typeId], "content", this.buildFactorContent(langCode));
    },
    // Note: Sync the Demand Sets Content to Page Data For CMS Editor.
    syncDemandsToPageData(langCode) {
      const typeId = `${langCode}-4`;
      const existingRows = Array.isArray(this.pageData[typeId]) ? this.pageData[typeId] : [];
      const demandSets = Array.isArray(this.demands[langCode]) ? this.demands[langCode] : [];
      const mappedRows = demandSets.map((set, index) => {
        const existing = existingRows[index] || {};
        return {
          ...existing,
          id: set.rowId || existing.id || null,
          type: typeId,
          title: set.title || this.getDefaultDemandTitle(langCode),
          subTitle: existing.subTitle || "",
          image: null,
          content: this.buildDemandSetContent(set),
        };
      });
      this.$set(this.pageData, typeId, mappedRows);
    },
    applySavedPlaygroundContent(langCode, typeSuffix, selectorPrefix) {
      const typeId = `${langCode}-${typeSuffix}`;
      const row = this.pageData[typeId];
      if (!row || !row.content) return;

      const target = document.querySelector(`${selectorPrefix}${langCode}`);
      if (!target) return;
      target.innerHTML = this.sanitizeHtml(row.content);
    },
    // Note: Sanitize the html content For CMS Editor (Remove the script, style, iframe, object, embed, link, meta tags / On Event Tags).
    sanitizeHtml(html = "") {
      if (!html) return "";
      const parser = new DOMParser();
      const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
      const wrapper = doc.body && doc.body.firstElementChild;
      if (!wrapper) return "";

      const blockedTags = ["script", "style", "iframe", "object", "embed", "link", "meta"];
      for (const tag of blockedTags) {
        const blockedNodes = wrapper.querySelectorAll ? wrapper.querySelectorAll(tag) : [];
        for (const node of Array.from(blockedNodes || [])) {
          node.remove();
        }
      }

      const nodes = wrapper.querySelectorAll ? wrapper.querySelectorAll("*") : [];
      for (const node of Array.from(nodes || [])) {
        for (const attr of Array.from(node.attributes || [])) {
          const name = attr.name.toLowerCase();
          const value = (attr.value || "").trim().toLowerCase();
          if (name.startsWith("on")) {
            node.removeAttribute(attr.name);
            continue;
          }
          if ((name === "href" || name === "src") && value.startsWith("javascript:")) {
            node.removeAttribute(attr.name);
          }
        }
      }

      return wrapper.innerHTML;
    },
    isSectionDeleted(type) {
      if (!type || !this.$data.pageData[type]) return false;
      return Number(this.$data.pageData[type].isDeleted) === 1;
    },
    onRemarkContentInput(type, content = "") {
      if (!type || !this.$data.pageData[type]) return;
      const sanitized = this.sanitizeHtml(content || "");
      this.$set(this.$data.pageData[type], "content", sanitized);
      this.$set(this.$data.pageData[type], "isDeleted", 0);
    },
    deleteSection(type) {
      if (!type || !this.$data.pageData[type]) return;
      this.$set(this.$data.pageData[type], "isDeleted", 1);
    },
    restoreSection(type) {
      if (!type || !this.$data.pageData[type]) return;
      this.$set(this.$data.pageData[type], "isDeleted", 0);
    },
    // Note: Get the clean html content For CMS Editor (Remove the button, editable, image tags).
    getCleanHtml(selector) {
      const el = document.querySelector(selector);
      if (!el) return "";

      const clone = el.cloneNode(true);
      const buttons = clone.querySelectorAll("button");
      for (const btn of Array.from(buttons || [])) {
        btn.remove();
      }

      const editables = clone.querySelectorAll('[contenteditable="true"]');
      for (const ed of Array.from(editables || [])) {
        ed.setAttribute("contenteditable", "false");
      }

      const images = clone.querySelectorAll("img");
      for (const img of Array.from(images || [])) {
        img.style.cursor = "default";
        img.style.pointerEvents = "none";
      }

      const cleaned = clone.innerHTML ? clone.innerHTML.trim() : "";
      return this.sanitizeHtml(cleaned);
    },
    // // Note: Normalize the image for API accepted format.
    // normalizeImageForApi(value) {
    //   if (!value) return null;
    //   if (typeof value !== "string") return null;

    //   const isBase64 = (str) => /^[A-Za-z0-9+/=\r\n]+$/.test(str);

    //   if (value.startsWith("data:image")) {
    //     const parts = value.split(",");
    //     if (parts.length <= 1) return null;
    //     const encoded = (parts[1] || "").trim();
    //     return isBase64(encoded) ? encoded : null;
    //   }

    //   if (value.startsWith("http") || value.startsWith("/")) {
    //     return null;
    //   }

    //   const normalized = value.trim();
    //   return isBase64(normalized) ? normalized : null;
    // },
    // // Note: Get the Image from API in each row 
    // resolveImageForApi(row = {}) {
    //   const normalizedImage = this.normalizeImageForApi(row.image);
    //   if (normalizedImage) return normalizedImage;

    //   if (typeof row.image === "string" && (row.image.startsWith("http") || row.image.startsWith("/"))) {
    //     return row.image;
    //   }

    //   return null;
    // },
    // Note: Submit the Content to API.
    async submitDetail() {
      const userId =
        this.$store &&
        this.$store.state &&
        this.$store.state.userInfo &&
        this.$store.state.userInfo.userId
          ? this.$store.state.userInfo.userId
          : null;
      const objList = [];

      for (const langCode of ["EN", "TC", "SC"]) {
        const row0 = this.pageData[`${langCode}-0`] || {};
        const row1 = this.pageData[`${langCode}-1`] || {};
        const row2 = this.pageData[`${langCode}-2`] || {};
        const row3 = this.pageData[`${langCode}-3`] || {};
        const row4List = Array.isArray(this.pageData[`${langCode}-4`]) ? this.pageData[`${langCode}-4`] : [];
        const row5 = this.pageData[`${langCode}-5`] || {};
        const row6 = this.pageData[`${langCode}-6`] || {};
        const row10 = this.pageData[`${langCode}-10`] || {};

        objList.push({
          id: row0.id,
          type: `${langCode}-0`,
          refId: this.refId,
          title: row0.title || "",
          subTitle: row0.subTitle || "",
          imageBaseStr: row0.imageBaseStr || "",
          content: "",
          createdBy: row0.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row0.isDeleted === "number" ? row0.isDeleted : 0,
        });

        objList.push({
          id: row1.id,
          type: `${langCode}-1`,
          refId: this.refId,
          title: row1.title || "",
          subTitle: row1.subTitle || "",
          image: null,
          content: this.getCleanHtml(`#projection-playground-${langCode}`),
          createdBy: row1.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row1.isDeleted === "number" ? row1.isDeleted : 0,
        });

        objList.push({
          id: row2.id,
          type: `${langCode}-2`,
          refId: this.refId,
          title: row2.title || "",
          subTitle: row2.subTitle || "",
          image: null,
          content: this.getCleanHtml(`#balance-playground-${langCode}`),
          createdBy: row2.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row2.isDeleted === "number" ? row2.isDeleted : 0,
        });

        objList.push({
          id: row3.id,
          type: `${langCode}-3`,
          refId: this.refId,
          title: row3.title || "Factors",
          subTitle: row3.subTitle || "",
          image: null,
          content: this.buildFactorContent(langCode),
          createdBy: row3.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row3.isDeleted === "number" ? row3.isDeleted : 0,
        });

        for (const row4 of row4List) {
          objList.push({
            id: row4.id,
            type: `${langCode}-4`,
            refId: this.refId,
            title: row4.title || this.getDefaultDemandTitle(langCode),
            subTitle: row4.subTitle || "",
            image: null,
            content: row4.content || "[]",
            createdBy: row4.createdBy || userId,
            updatedBy: userId,
            isDeleted: typeof row4.isDeleted === "number" ? row4.isDeleted : 0,
          });
        }
        const deletedRowIds = Array.isArray(this.deletedDemandRowIds[langCode]) ? this.deletedDemandRowIds[langCode] : [];
        for (const deletedId of deletedRowIds) {
          if (!deletedId) continue;
          objList.push({
            id: deletedId,
            type: `${langCode}-4`,
            refId: this.refId,
            title: this.getDefaultDemandTitle(langCode),
            subTitle: "",
            image: null,
            content: "",
            createdBy: userId,
            updatedBy: userId,
            isDeleted: 1,
          });
        }

        objList.push({
          id: row5.id,
          type: `${langCode}-5`,
          refId: this.refId,
          content: this.getCleanHtml(`.playground[data-type-id="${langCode}-5"]`) || "",
          createdBy: row5.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row5.isDeleted === "number" ? row5.isDeleted : 0,
        });

        objList.push({
          id: row6.id,
          type: `${langCode}-6`,
          refId: this.refId,
          content: this.getCleanHtml(`.playground[data-type-id="${langCode}-6"]`) || "",
          createdBy: row6.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row6.isDeleted === "number" ? row6.isDeleted : 0,
        });

        objList.push({
          id: row10.id,
          type: `${langCode}-10`,
          refId: this.refId,
          content: Number(row10.isDeleted) === 1 ? "" : (row10.content || ""),
          createdBy: row10.createdBy || userId,
          updatedBy: userId,
          isDeleted: typeof row10.isDeleted === "number" ? row10.isDeleted : 0,
        });
      }

      const preObj = this.getAuthObj

      try {
        const result = await this.$store.dispatch("eightCentres/insertOrUpdateDetail", {preObj,objList}, );
        // const result = await this.$store.dispatch("eightCentres/insertOrUpdateDetail",preObj);
        if (result && result.data && result.data.errorCode === 0) {
          this.$router.push("/main/eightCentresContent");
        }
      } catch (err) {
        console.error("Save Error:", err);
      }
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return Promise.resolve(null);

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataUrl = e.target.result;
          this.imageBase64 = dataUrl;
          this.imagePreview = dataUrl;
          resolve(dataUrl);
        };
        reader.onerror = () => reject(new Error("FileReader error"));
        reader.readAsDataURL(file);
      });
    },
    clearImage(langCode, index) {
      this.factors[langCode][index].image = null;
      this.syncFactorsToPageData(langCode);
    },
    clearDemandImage(langCode, setIndex, index) {
      this.demands[langCode][setIndex].items[index].image = null;
      this.syncDemandsToPageData(langCode);
    },
    removeFactor(langCode, index) {
      this.factors[langCode].splice(index, 1);
      if (!this.factors[langCode].length) {
        this.factors[langCode].push(this.createDefaultFactor());
      }
      this.syncFactorsToPageData(langCode);
    },
    removeDemandSet(langCode, setIndex) {
      const targetList = this.demands[langCode];
      if (!Array.isArray(targetList) || !targetList[setIndex]) return;
      const removedSet = targetList[setIndex];
      if (removedSet && removedSet.rowId) {
        if (!Array.isArray(this.deletedDemandRowIds[langCode])) {
          this.$set(this.deletedDemandRowIds, langCode, []);
        }
        if (!this.deletedDemandRowIds[langCode].includes(removedSet.rowId)) {
          this.deletedDemandRowIds[langCode].push(removedSet.rowId);
        }
      }
      this.demands[langCode].splice(setIndex, 1);
      this.syncDemandsToPageData(langCode);
    },
    addFactor(langCode) {
      if (!this.factors[langCode]) {
        this.$set(this.factors, langCode, []);
      }
      this.factors[langCode].push(this.createDefaultFactor());
      this.syncFactorsToPageData(langCode);
    },
    addDemandSet(langCode) {
      if (!this.demands[langCode]) {
        this.$set(this.demands, langCode, []);
      }
      this.demands[langCode].push(this.createDefaultDemandSet(langCode));
      this.syncDemandsToPageData(langCode);
    },
    addDemand(langCode, setIndex) {
      if (!this.demands[langCode] || !this.demands[langCode][setIndex]) return;
      this.demands[langCode][setIndex].items.push(this.createDefaultDemand());
      this.syncDemandsToPageData(langCode);
    },
    triggerUploadFor(langCode, index) {
      this.activeIndex = index; // Remember which factor we are uploading for
      this.activeLangCode = langCode; // Remember the language code
      this.activeUploadSection = "factor";

      // Look for the ref
      const fileInput = this.$refs.hiddenFile;

      // Fix: Safely trigger the click whether Vue returned an Array, a direct element,
      // or if we need to fall back to the direct HTML ID.
      if (Array.isArray(fileInput)) {
        fileInput[0].click();
      } else if (fileInput && typeof fileInput.click === "function") {
        fileInput.click();
      } else {
        // Bulletproof fallback using the exact ID from your HTML template
        const fallbackInput = document.getElementById("hiddenFileInput");
        if (fallbackInput) {
          fallbackInput.click();
        } else {
          console.error("Could not find the hidden file input element.");
        }
      }
    },
    triggerDemandUpload(langCode, setIndex, index) {
      this.activeDemandSetIndex = setIndex;
      this.activeIndex = index;
      this.activeLangCode = langCode;
      this.activeUploadSection = "demand";

      const fileInput = this.$refs.hiddenFile;
      if (Array.isArray(fileInput)) {
        fileInput[0].click();
      } else if (fileInput && typeof fileInput.click === "function") {
        fileInput.click();
      } else {
        const fallbackInput = document.getElementById("hiddenFileInput");
        if (fallbackInput) fallbackInput.click();
      }
    },
    onHiddenFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onerror = () => {
        console.error("FileReader failed to read the selected image.");
        if (event && event.target) event.target.value = "";
      };
      reader.onload = (e) => {
        try {
          const base64Data = e.target.result;
          const lang = this.activeLangCode;

          if (this.activeUploadSection === "factor" && this.activeIndex !== null) {
            const list = this.factors[lang];
            const factor = list && list[this.activeIndex];
            if (factor) {
              this.$set(factor, "image", base64Data);
              this.syncFactorsToPageData(lang);
            }
          } else if (
            this.activeUploadSection === "demand" &&
            this.activeDemandSetIndex !== null &&
            this.activeIndex !== null
          ) {
            const sets = this.demands[lang];
            const set = sets && sets[this.activeDemandSetIndex];
            const item = set && set.items && set.items[this.activeIndex];
            if (item) {
              this.$set(item, "image", base64Data);
              this.syncDemandsToPageData(lang);
            }
          }
        } catch (err) {
          console.error("Image upload handling failed:", err);
        } finally {
          this.activeDemandSetIndex = null;
          this.activeIndex = null;
          this.activeUploadSection = null;
          if (event && event.target) event.target.value = "";
        }
      };
      reader.readAsDataURL(file);
    },
    async changeImage(e, typeId){
      const dataUrl = await this.handleImageUpload(e);
      if (!dataUrl) return;
      if (this.pageData[typeId]) {
        this.$set(this.pageData[typeId], 'imageBaseStr', dataUrl);
      } else {
        console.warn('Invalid pageData key:', typeId);
      }
    },
    async loadCentres() {
      try {
        let obj = this.getAuthObj;
        obj.startRow = 0;
        obj.maxRows = 10000;
        const res = await this.$store.dispatch("eightCentres/searchCentre", obj);
        console.log("Full API Response:", res); // DEBUG: Look at this in F12

        if (res && res.data && res.data.errorCode === 0) {
          // CHECK: Is the list in res.data.result or res.data.list or res.data.result.list?
          // Based on typical CMS patterns, it's often in .list
          this.centresList = res.data.list || res.data.result || [];

          console.log("CentresList assigned:", this.centresList);
        } else {
          this.centresList = [];
        }
      } catch (err) {
        console.error("API error loadCentres:", err);
        this.centresList = [];
      }
    },
    async loadDetail(targetId) {
      const self = this
      self.$data.isLoading = true; // 4. Set loading state before API call
      try {
        if (!targetId) return;
        if (self._searchDetailCancelSource) {
          self._searchDetailCancelSource.cancel();
        }
        self._searchDetailCancelSource = axios.CancelToken.source();
        const response = await self.$store.dispatch("eightCentres/searchDetail", {
          ...self.getAuthObj,
          refId: targetId,
          cancelToken: self._searchDetailCancelSource.token,
        });
        if (!response || !response.data || response.data.errorCode !== 0) return;

        self.detailId = targetId || self.refId || "";
        const result = Array.isArray(response.data.result) ? response.data.result : [];

        const validTypes = new Set(Object.keys(self.pageData));
        const sourceRows = result.filter((row) => validTypes.has(row.type));

        const getResultRowByType = (typeStr) => sourceRows.find((row) => row.type === typeStr) || {};

        const nextPageData = Object.keys(self.pageData).reduce((acc, key) => {
          const isDemandType = key.endsWith("-4");
          acc[key] = isDemandType
            ? []
            : {
                type: key,
                title: "",
                subTitle: "",
                // image: null,
                // imageStr: "",
                imageBaseStr: "",
                content: "",
                isDeleted: 0,
              };
          return acc;
        }, {});

        for (const row of sourceRows) {
          const isDemandType = row.type.endsWith("-4");
          const rowContent = typeof row.content === "string"
            ? row.content.replaceAll(`contenteditable="false"`, `contenteditable="true"`)
            : "";

          if (isDemandType) {
            const demandRows = Array.isArray(nextPageData[row.type]) ? nextPageData[row.type] : [];
            demandRows.push({
              ...row,
              type: row.type,
              content: rowContent,
            });
            nextPageData[row.type] = demandRows;
            continue;
          }

          const baseRow = nextPageData[row.type] || { type: row.type, title: "", subTitle: "", image: null, content: "" };
          nextPageData[row.type] = {
            ...baseRow,
            ...row,
            type: row.type,
            content: rowContent,
            isDeleted: typeof row.isDeleted === "number" ? row.isDeleted : 0,
          };

          if(nextPageData[row.type].content.trim().length ==0 ){
            if(row.type.endsWith("-1"))nextPageData[row.type].content =section1Node
            if(row.type.endsWith("-2"))nextPageData[row.type].content =section2Node
          }
        }

        self.$data.pageData = nextPageData

        self.$data.deletedDemandRowIds = { EN: [], TC: [], SC: [] };

        for (const langCode of ["EN", "TC", "SC"]) {
          const factorRow = getResultRowByType(`${langCode}-3`);
          const parsed = self.parseFactorContent(factorRow.content || "");
          self.$set(self.factors, langCode, parsed);
          self.syncFactorsToPageData(langCode);

          const demandRows = sourceRows.filter((row) => row.type === `${langCode}-4`);
          const parsedDemand = self.parseDemandRows(demandRows, langCode);
          self.$set(self.demands, langCode, parsedDemand.length ? parsedDemand : [self.createDefaultDemandSet(langCode)]);
          self.syncDemandsToPageData(langCode);
        }

        self.$nextTick(() => {
          for (const langCode of ["EN", "TC", "SC"]) {
            self.applySavedPlaygroundContent(langCode, "1", "#projection-playground-");
            self.applySavedPlaygroundContent(langCode, "2", "#balance-playground-");
          }
        });

        console.log("Loaded centre details (filtered by known types):", sourceRows);
      } catch (err) {
        if (axios.isCancel(err)) return;
        console.error("Failed to load centre details:", err);
        console.error("Failed to load centre details stack:", err && err.stack ? err.stack : "no stack");
      } finally {
      self.$data.isLoading = false
      }
    },
    onRefIdChange(e) {
      const foundOpt = this.$data.centresList.filter(({id})=> id == e.target.value)[0]
      this.$data.pageData["EN-0"].title = foundOpt.titleEn
      this.$data.pageData["SC-0"].title = foundOpt.titleSc
      this.$data.pageData["TC-0"].title = foundOpt.titleTc
      this.$data.pageData.changeDex++
    },
    updateText(event, langCode, index) {
      if (!this.factors[langCode] || !this.factors[langCode][index]) return;
      this.factors[langCode][index].text = event.target.innerText;
      this.syncFactorsToPageData(langCode);
    },
    updateFactorUrl(event, langCode, index) {
      if (!this.factors[langCode] || !this.factors[langCode][index]) return;
      this.factors[langCode][index].url = this.normalizeFactorUrl(event.target.innerText);
      this.syncFactorsToPageData(langCode);
    },
    updateDemandTitle(event, langCode, setIndex) {
      if (!this.demands[langCode] || !this.demands[langCode][setIndex]) return;
      this.demands[langCode][setIndex].title = event.target.innerText;
      this.syncDemandsToPageData(langCode);
    },
    removeDemand(langCode, setIndex, index) {
      if (!this.demands[langCode] || !this.demands[langCode][setIndex]) return;
      this.demands[langCode][setIndex].items.splice(index, 1);
      if (!this.demands[langCode][setIndex].items.length) {
        this.demands[langCode][setIndex].items.push(this.createDefaultDemand());
      }
      this.syncDemandsToPageData(langCode);
    },
    updateDemandText(event, langCode, setIndex, index) {
      if (!this.demands[langCode] || !this.demands[langCode][setIndex] || !this.demands[langCode][setIndex].items[index]) return;
      this.demands[langCode][setIndex].items[index].text = event.target.innerText;
      this.syncDemandsToPageData(langCode);
    },
    updateDemandUrl(event, langCode, setIndex, index) {
      if (!this.demands[langCode] || !this.demands[langCode][setIndex] || !this.demands[langCode][setIndex].items[index]) return;
      this.demands[langCode][setIndex].items[index].url = this.normalizeDemandUrl(event.target.innerText);
      this.syncDemandsToPageData(langCode);
    },
    addSectionLinkItem(sectionId){
      const targetSection = $(sectionId)[0]
      const targetType = targetSection.dataset.typeId
      $(sectionId).append(linksRowNode);
      this.$data.pageData[targetType].content = targetSection.innerHTML
    },
    getDivIndex(element) {
      const siblings = Array.from(element.parentNode.children);
      return siblings.indexOf(element);
    },
    resetSectionContent(secIndex, lang){
      console.debug(`${lang}-${secIndex}`)
      const sectionKey = `${lang}-${secIndex}`;

      switch(secIndex){
        case 1:
        case "1":
            this.$data.pageData[sectionKey].content = section1Node
          break;
        case 2:
        case "2":
            this.$data.pageData[sectionKey].content = section2Node
          break;
        default:
      }
      if (this.$data.pageData[sectionKey]) {
        this.$set(this.$data.pageData[sectionKey], "isDeleted", 0);
      }

      this.$data.pageData.changeDex++
    }
  },
};
</script>

<style>
.image-previewer{
  position: relative;
  aspect-ratio: 16/9;
  border: 1px solid #ccc;
  max-width: 420px;
}
.image-previewer img{
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: contain;
}
.sr-only{
  position: absolute !important;
}
.projection-content__right-content{
  position: relative;
  border: 1px dashed #ccc;
}

.playground--link{
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.diamond-icon{
  position: relative;
  padding-bottom: 32px;
}
.diamond-icon:hover{
  background-color: #fefefe;
}
.diamond-icon .website_hide{
  position: absolute;
  inset: auto 0 0 ;
}

.diamond-icon .occupation_link{
  flex: 0 0 50%;
}

.playground--link .link-remove-btn{
  position: absolute;
  inset: 0 0 auto auto;
  cursor: pointer;
}

.playground--link .link-remove-btn:hover{
  text-decoration: underline;
}
.projection-content__right-content{
  padding-bottom: 32px;
}
.remark-editor--disabled{
  opacity: 0.55;
  filter: grayscale(0.2);
}
.section-disabled{
  opacity: 0.55;
  filter: grayscale(0.2);
  pointer-events: none;
}
.item-url{
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
